var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-list',{attrs:{"title":"Карта сайта","breadcrumbs":_vm.breadcrumbs,"data-source":_vm.dataSource,"custom-create-item-fields":_vm.createItemFields,"custom-create-item-model":_vm.createItemModel}})
}
var staticRenderFns = []

export { render, staticRenderFns }